import React from 'react';
import { connect } from 'react-redux';
import Table from './table';

const App = () => (
  <div>
    <Table />
  </div>
);

export default connect()(App);



// WEBPACK FOOTER //
// ./app/components/app.js